export default __webpack_public_path__ + "static/media/lion-cub.969d75f0.png";